import { createContext, useContext } from 'react'
import type { TenantThemeMode } from '@propbix/constants/public'

export type ResolvedTheme = 'light' | 'dark'

export type ThemeContextValue = {
  mode: TenantThemeMode
  resolved: ResolvedTheme
  setMode: (mode: TenantThemeMode) => void
  toggleLightDark: () => void
}

export const ThemeContext = createContext<ThemeContextValue | null>(null)

export function useTheme() {
  const ctx = useContext(ThemeContext)
  if (ctx === null) {
    throw new Error('useTheme must be used within ThemeProvider')
  }
  return ctx
}
